import React from 'react';

import './App.css';
import './styles/game.css';

const App: React.FC = () => {
  return (
    <div>
      <div style={{ fontFamily: 'SourceSansPro', position: 'absolute', left: '-1000px', visibility: 'hidden' }}>.</div>
      <div id="phaser-game" className="padding"/>
    </div>
  );
};

export default App;
